<template>
	<el-card class="clearfloat faultRecord">
		<el-button
			class="outputBtn"
			type="primary"
			size="mini"
			@click="handleExport"
			v-if="btnPer('sta_outputFaultRecord')"
			:disabled="selList.length == 0"
		>
			批量导出
		</el-button>
		<!-- 筛选表单 -->
		<el-form class="right" ref="tableFilter" inline :model="tableFilter">
			<el-form-item prop="codeMacSn">
				<el-input
					size="mini"
					placeholder="故障代码/MAC地址/SN"
					v-model="tableFilter.codeMacSn"
				></el-input>
			</el-form-item>
			<el-form-item prop="productTypeId">
				<el-select
					placeholder="产品类型"
					size="mini"
					v-model="tableFilter.productTypeId"
					@change="(val) => getProductModels('filter', val)"
					clearable
				>
					<el-option
						v-for="item in productTypes"
						:key="item.id"
						:value="item.id"
						:label="item.productType"
					></el-option>
				</el-select>
			</el-form-item>
			<el-form-item prop="productId">
				<el-select
					placeholder="产品型号"
					:disabled="tableFilter.productTypeId == null"
					size="mini"
					v-model="tableFilter.productId"
					clearable
				>
					<el-option
						v-for="item in productModels4Filter"
						:key="item.id"
						:value="item.id"
						:label="item.productModel"
					></el-option>
				</el-select>
			</el-form-item>
			<el-form-item prop="productId">
				<el-date-picker
					v-model.trim="pickTime"
					size="mini"
					@change="handleChangePickTime"
					:picker-options="pickerOptions"
					type="datetimerange"
					start-placeholder="首次上报开始日期"
					end-placeholder="首次上报结束日期"
				></el-date-picker>
			</el-form-item>
			<el-form-item prop="ifRead">
				<el-select
					placeholder="消息状态"
					size="mini"
					v-model="tableFilter.ifRead"
					clearable
				>
					<el-option :value="true" label="已读"></el-option>
					<el-option :value="false" label="未读"></el-option>
				</el-select>
			</el-form-item>

			<el-form-item>
				<el-button size="mini" @click="handleResetFilter">
					重置
				</el-button>
				<el-button type="primary" size="mini" @click="getList">
					搜索
				</el-button>
			</el-form-item>
		</el-form>
		<!-- 表格 -->
		<el-table
			ref="table"
			:data="tableData"
			style="width: 100%"
			@selection-change="handleSelectionChange"
		>
			<el-table-column type="selection" width="55"></el-table-column>
			<el-table-column
				label="序号"
				fixed="left"
				type="index"
				width="80"
			></el-table-column>
			<el-table-column
				label="产品类型"
				width="120"
				prop="productTypeId"
				fixed="left"
				:formatter="(row) => escapeData('productType', row)"
			></el-table-column>
			<el-table-column
				label="产品型号"
				prop="productId"
				fixed="left"
				:formatter="(row) => escapeData('productModel', row)"
			></el-table-column>
			<el-table-column
				width="150"
				label="SN序列号"
				prop="deviceSN"
				fixed="left"
			>
				<template slot-scope="scope">
					<el-tooltip :content="scope.row.deviceSN">
						<span>{{
							$utils.handleDealLongTxt(scope.row.deviceSN)
						}}</span>
					</el-tooltip>
				</template>
			</el-table-column>
			<el-table-column
				label="故障代码"
				prop="code"
				width="80"
			></el-table-column>
			<el-table-column label="通知内容" prop="showMessage" width="250">
				<template slot-scope="scope">
					<el-tooltip :content="scope.row.showMessage">
						<span>{{
							$utils.handleDealLongTxt(scope.row.showMessage)
						}}</span>
					</el-tooltip>
				</template>
			</el-table-column>
			<el-table-column
				label="消息状态"
				prop="ifRead"
				:formatter="
					(row) => {
						return row.ifRead ? '已读' : '未读';
					}
				"
			></el-table-column>
			<el-table-column
				label="首次上报时间"
				prop="reportTime"
				width="200"
				:formatter="(row) => $utils.formatDate(row.reportTime)"
			></el-table-column>
			<el-table-column
				label="更新时间"
				prop="updateTime"
				width="200"
				:formatter="(row) => $utils.formatDate(row.updateTime)"
			></el-table-column>
			<el-table-column label="操作" fixed="right" width="200">
				<template slot-scope="scope">
					<el-link
						:underline="false"
						size="mini"
						type="primary"
						v-if="btnPer('sta_checkFaultRecord')"
						@click.native.prevent="handleInfo(scope.row)"
						>查看</el-link
					>
					<el-link
						class="marginL10"
						:underline="false"
						size="mini"
						type="danger"
						v-if="btnPer('sta_delFaultRecord')"
						@click.native.prevent="handleDelete(scope.row)"
						>删除</el-link
					>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<el-pagination
			class="marginT20 right"
			align="right"
			@size-change="(pageSize) => getList('pageSize', pageSize, true)"
			@current-change="(page) => getList('page', page)"
			:current-page.sync="pageNumber"
			:page-sizes="[10, 20, 30, 40, 50, 100]"
			:page-size.sync="pageSize"
			layout="total, sizes, prev, pager, next, jumper"
			:total="total"
		></el-pagination>
		<!-- 弹窗 -->
		<el-dialog title="故障详情" width="50%" :visible.sync="dialogVisible">
			<el-form ref="form" :model="form" label-width="150px">
				<el-form-item label="产品类型" prop="productTypeId">
					<span>{{ escapeData("productType", form) }}</span>
				</el-form-item>
				<el-form-item label="产品型号" prop="productId">
					<span>{{ escapeData("productModel", form) }}</span>
				</el-form-item>
				<el-form-item label="故障代码" prop="code">
					<span>{{ form.code }}</span>
				</el-form-item>
				<el-form-item label="故障含义" prop="content">
					<span>{{ form.content }}</span>
				</el-form-item>
				<el-form-item label="SN序列号" prop="deviceSN">
					<span>{{ form.deviceSN }}</span>
				</el-form-item>
				<el-form-item label="消息状态" prop="ifRead">
					<span>{{ form.ifRead ? "已读" : "未读" }}</span>
				</el-form-item>
				<el-form-item label="首次上报时间" prop="ifRead">
					<span>{{ $utils.formatDate(form.reportTime) }}</span>
				</el-form-item>
				<el-form-item label="最后上报时间" prop="ifRead">
					<span>{{ $utils.formatDate(form.updateTime) }}</span>
				</el-form-item>
				<el-form-item label="通知内容" prop="showMessage">
					<el-input
						type="textarea"
						disabled
						:rows="3"
						:value="form.showMessage"
					></el-input>
				</el-form-item>
			</el-form>
		</el-dialog>
	</el-card>
</template>

<script>
import { Message } from "element-ui";
export default {
	data() {
		return {
			pickerOptions: {
				//只允许选择今天之前的日期(包括今天)
				disabledDate(time) {
					return time.getTime() > Date.now();
				},
			},
			pickTime: null,
			total: 0,
			dialogVisible: false,
			act: "",
			pageNumber: 1,
			pageSize: 10,
			tableFilter: {
				productTypeId: null,
				productId: null,
				codeMacSn: null,
				ifRead: null,
				reportStartTime: null,
				reportEndTime: null,
			},
			form: {},
			errCodes: [],
			selList: [],
			productTypes: [],
			productModels4Filter: [],
			productModelsAll: [],
			tableData: [],
			columns: [
				{
					prop: "productTypeName",
					label: "产品类型",
				},
				{
					prop: "productName",
					label: "产品型号",
				},
				{
					prop: "deviceSN",
					label: "SN序列号",
				},
				{
					prop: "code",
					label: "故障代码",
				},
				{
					prop: "showMessage",
					label: "通知内容",
				},
				{
					prop: "ifRead",
					label: "消息状态",
				},
				{
					prop: "reportTime",
					label: "首次上报时间",
				},
				{
					prop: "updateTime",
					label: "更新时间",
				},
			],
		};
	},
	created() {
		this.getList();
		this.getProductTypes();
		this.getProductModelsAll();
	},
	methods: {
		getList: function (type, val, isReload = false) {
			isReload ? this.pageNumber = 1 : null;
			if (type) {
				this[type] = val;
			}
			let para = {
				pageNumber: this.pageNumber,
				pageSize: this.pageSize,
				...this.tableFilter,
			};
			this.$http.standFaultRecords(para).then((res) => {
				this.tableData = res.data.data.list;
				this.total = res.data.data.total;
			});
		},
		handleSelectionChange: function (val) {
			this.selList = val;
		},
		handleChangePickTime: function (val) {
			if (val) {
				this.tableFilter.reportStartTime = this.$utils.formatDate(
					val[0]
				);
				this.tableFilter.reportEndTime = this.$utils.formatDate(val[1]);
			} else {
				this.tableFilter.reportStartTime = null;
				this.tableFilter.reportEndTime = null;
			}
		},
		// 编辑
		handleInfo: function (row) {
			this.$http.standFaultRecordInfo(row.id).then((res) => {
				if (res.data.success) {
					this.dialogVisible = true;
					this.form = res.data.data;
					this.$http.standFaultRecordRead(row.id).then((res) => {
						if (res.data.success) {
							this.getList();
						}
					});
				}
			});
		},
		// 导出
		handleExport: function () {
			this.$http.standFaultRecordExport().then((res) => {
				if (res.data.success) {
					this.$http.deviceExport().then((res) => {
						require.ensure([], () => {
							const {
								export_json_to_excel,
							} = require("../../../assets/js/Export2Excel");
							var tHeader = [],
								filterVal = [];
							this.columns.forEach((i) => {
								if (i.label != "操作") {
									tHeader.push(i.label);
									filterVal.push(i.prop);
								}
							});
							const list = Object.assign([], this.selList);
							list.forEach((item, index) => {
								for (var x in item) {
									if (x.indexOf("Time") != -1) {
										item[x] = this.$filters.dateFilter(
											item[x],
											""
										);
									}
									if (x == "ifRead") {
										item[x] = item[x] ? "已读" : "未读";
									}
								}
							});
							const data = this.formatJson(filterVal, list);
							export_json_to_excel(
								tHeader,
								data,
								"故障记录" + this.$utils.formatDate(new Date())
							);
						});
					});
				}
			});
		},
		// 删除
		handleDelete: function (row) {
			this.$confirm(
				"确认删除此故障记录（" + row.deviceSN + "）吗？",
				"提示",
				{
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}
			).then(() => {
				this.$http.standFaultRecordDel(row.id).then((res) => {
					if (res.data.success) {
						this.getList();
					}
				});
			});
		},
		// 重置筛选表单
		handleResetFilter: function () {
			this.$refs.tableFilter.resetFields();
			this.tableFilter.reportStartTime = null;
			this.tableFilter.reportEndTime = null;
			this.pickTime = null;
			this.getList();
		},
		// —————————————— 获取关联数据 ——————————————
		// 获取产品类型列表
		getProductTypes: function () {
			this.$http.productTypesAll().then((res) => {
				if (res.data.success) {
					this.productTypes = res.data.data;
				}
			});
		},
		// 获取产品型号列表
		getProductModels: function (type, val) {
			if (val) {
				this.$http
					.productModuleAll({
						productTypeId: val,
					})
					.then((res) => {
						if (res.data.success) {
							this.productModels4Filter = res.data.data;
						}
					});
			} else {
				this.productModels4Filter = [];
				this.tableFilter.productId = null;
			}
		},
		// 获取产品型号列表
		getProductModelsAll: function (type, val) {
			this.$http.productModuleAll().then((res) => {
				if (res.data.success) {
					this.productModelsAll = res.data.data;
				}
			});
		},
		// 获取故障码属性
		getErrorCodes: function (val) {
			this.$http
				.productModelFuncListALL({
					productId: val,
				})
				.then((res) => {
					res.data.data.forEach((item) => {
						if (item.identify == "error_code") {
							this.errCodes = JSON.parse(item.bounds).items;
						}
					});
				});
		},
		// 获取故障含义
		getErrorContent: function (val) {
			this.form.content = this.errCodes[val];
		},
		// 转化数据
		escapeData: function (type, row) {
			switch (type) {
				case "productType":
					for (let i in this.productTypes) {
						if (this.productTypes[i].id == row.productTypeId) {
							return this.productTypes[i].productType;
						}
					}
					return "--";
				case "productModel":
					for (let i in this.productModelsAll) {
						if (this.productModelsAll[i].id == row.productId) {
							return this.productModelsAll[i].productModel;
						}
					}
					return "--";
				default:
					return "--";
			}
		},
		// 整理JSON
		formatJson(filterVal, jsonData) {
			return jsonData.map((v) => filterVal.map((j) => v[j]));
		},
		// 判断按钮权限
		btnPer: function (name) {
			let list = this.$store.state.standard.menuNodeList,
				flag = false;
			for (let i in list) {
				if (list[i].href == name) {
					flag = true;
					break;
				}
			}
			return flag;
		},
	},
};
</script>
<style scoped>
.faultRecord {
	vertical-align: top;
}
.outputBtn {
	margin-top: 7px;
	float: left;
}
</style>
